import axios from 'axios';
import constants from '../const.js';
import { helper } from '../components/common/helper.js';
const getToken = () => {
    return localStorage.getItem('token').slice(7);
}

const getBearerToken = () => {
    return localStorage.getItem('token');
}

const getTokenParam = () => {
    return `?token=${localStorage.getItem("token").slice(7)}`;
}

function isFolder(file) {
    return file.key.endsWith('/')
}

const grouper = (files, root) => {
    const fileTree = {
        contents: [],
        children: {}
    }

    files.map((file) => {
        file.relativeKey = (file.newKey || file.key).substr(root.length)
        let currentFolder = fileTree
        const folders = file.relativeKey.split('/')
        folders.map((folder, folderIndex) => {
            if (folderIndex == folders.length - 1 && isFolder(file)) {
                for (const key in file) {
                    currentFolder[key] = file[key]
                }
            }
            if (folder == '') {
                return
            }
            const isAFile = (!isFolder(file) && (folderIndex === folders.length - 1))
            if (isAFile) {
                currentFolder.contents.push({
                    ...file,
                    keyDerived: true
                })
            } else {
                if (folder in currentFolder.children === false) {
                    currentFolder.children[folder] = {
                        contents: [],
                        children: {}
                    }
                }
                currentFolder = currentFolder.children[folder]
            }
        })
    })
    function addAllChildren(level, prefix) {
        if (prefix !== '') {
            prefix += '/'
        }
        let files = []
        for (const folder in level.children) {
            files.push({
                ...level.children[folder],
                contents: undefined,
                keyDerived: true,
                key: root + prefix + folder + '/',
                relativeKey: prefix + folder + '/',
                children: addAllChildren(level.children[folder], prefix + folder),
                size: 0
            })
        }
        files = files.concat(level.contents)
        return files
    }

    files = addAllChildren(fileTree, '')
    return fileTree
}

const imageURL = (path) => {
    return `${constants.CONTENT_DOMAIN}download/sus-media/galleries${path}${getTokenParam()}`;
  };

const fetchGalleryAPI = async (galleryId, callback) => {
    if (localStorage.getItem("token") != null) {
        axios
            .get(`${constants.CONTENT_DOMAIN}files/directory/galleries/${galleryId}${getTokenParam()}`)
            .then(async (res) => {
                let fileTree;
                
                if (Array.isArray(res.data)) {
                    // Old format: array from S3 - pass through grouper
                    fileTree = grouper(res.data, '/' + galleryId)
                } else if (res.data && typeof res.data === 'object' && (res.data.files !== undefined || res.data.children !== undefined)) {
                    // New format: {files: ["name1", "name2"], children: {albumName: {files: [...]}}}
                    // Transform to {contents: [...], children: {...}} format with proper paths
                    const transformStructure = (data, parentPath = '') => {
                        const transformed = {
                            contents: [],
                            children: {}
                        };
                        
                        // Transform files array to contents array with key property
                        if (Array.isArray(data.files)) {
                            transformed.contents = data.files.map(filename => ({
                                key: `${parentPath}/${filename}`,
                                size: 0
                            }));
                        }
                        
                        // Transform children recursively
                        if (data.children && typeof data.children === 'object') {
                            for (const folderName in data.children) {
                                const childPath = `${parentPath}/${folderName}`;
                                transformed.children[folderName] = transformStructure(data.children[folderName], childPath);
                            }
                        }
                        
                        return transformed;
                    };
                    
                    fileTree = transformStructure(res.data, `/${galleryId}`);
                } else {
                    // Fallback: treat as array
                    fileTree = grouper(res.data, '/' + galleryId)
                }
                
                helper.loadGalleryTree(fileTree, imageURL)
                callback(fileTree)
                // setGallery(fileTree)
                // setReadyToLoad(true)
            })
            .catch((err) => {
                console.log(err);
            });
    }
}

export {
    fetchGalleryAPI

}